/**
 * Subscription helpers — API returns nested plan as `plan_details` (not `plan`) for reads.
 */

export function extractSubscriptionList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

/** Display name for current subscription (DRF hides `plan` on read). */
export function getSubscriptionPlanName(subscription) {
  if (!subscription) return null;
  const nested = subscription.plan_details?.name;
  if (nested) return nested;
  if (typeof subscription.plan === 'object' && subscription.plan?.name) {
    return subscription.plan.name;
  }
  return null;
}

/** Numeric plan id if available */
export function getSubscriptionPlanId(subscription) {
  if (!subscription) return null;
  if (subscription.plan_details?.id != null) return subscription.plan_details.id;
  if (subscription.plan != null && typeof subscription.plan === 'number') {
    return subscription.plan;
  }
  return null;
}

/**
 * True if org has no subscription row or is on a $0 / free catalog plan (upgrade prompts).
 * Active Stripe subscriptions without a $0 price are treated as paid.
 */
export function isFreeTierOrNoSubscription(subscription) {
  if (!subscription) return true;
  const hasStripe = Boolean(subscription.stripe_subscription_id);
  const activeStripe =
    hasStripe &&
    (subscription.stripe_status === 'active' ||
      subscription.stripe_status === 'trialing');
  const price = subscription.plan_details?.price_usd;
  if (activeStripe && (price == null || price === '')) {
    return false;
  }
  if (price == null || price === '') return true;
  const n = Number(price);
  if (Number.isNaN(n)) return true;
  return n <= 0;
}
